import { ValidateAny } from "./ValidateAny";
import { Moment } from "moment";

export class ValidateDateRange<TRoot> extends ValidateAny<{ startDate: Moment, endDate: Moment }, TRoot> {
    public required(condition?: (root: TRoot) => boolean) {
        this.isRequired = true;

        this.add((value: any, root: TRoot) => {
            if ((value && value.startDate && value.endDate) || value === false) {
                return null;
            }
            if (condition && !condition(root)) {
                return null;
            }
            if (!value.startDate && !value.endDate)
                return { message: `Start- en einddatum zijn verplicht` };
            else if (!value.startDate)
                return { message: `Startdatum is verplicht` };
            else if (!value.endDate)
                return { message: `Einddatum is verplicht` };
        });
        return this;
    } 
    public order() {
        this.isRequired = true;

        this.add((value: any, root: TRoot) => {
            if (!value || !value.startDate || !value.endDate)
                return null;
            
            if (value.endDate < value.startDate)
                return { message: 'De startdatum moet voor de einddatum liggen' };
        });
        return this;
    }
    constructor(name: string, key: string) {
        super(name, key);

        this.add((value: any, root: TRoot) => {
            if (!value) {
                return null;
            }
            const startDate: Moment = value.startDate;
            const endDate: Moment = value.endDate;

            if ((startDate && !startDate.isValid()) || (endDate && !endDate.isValid()))
                return { message: `${this.name || 'Dit veld'} bevat een ongeldige datum` };

            return null;
        });
    }
}
